<template>
  <v-row justify="center" v-if="programa && estudiante">
    <v-dialog v-model="dialog" scrollable :overlay="false" max-width="860px" transition="dialog-transition">
      <v-card>
        <v-card-text class="pa-0">
          <div id="html-kardexupi-bol">

            <!-- TOP BAR -->
            <div class="kd-topbar">
              <span class="kd-topbar-title">{{ programa.nombre_compuesto }}</span>
              <strong>Documento oficial</strong>
            </div>


            <div class="kd-doc-title mx-5">Estado de cuenta</div>
            <!-- BANNER -->
            <div class="kd-banner">
              <img :src="getimgkardex(programa.universidad)" class="kd-banner-img" />
            </div>

            <!-- STUDENT INFO -->
            <div class="kd-student-section">
              <div class="kd-info-field">
                <div class="kd-field-label">{{ posgraduante_str }}</div>
                <div class="kd-field-value">{{ estudiante.nombres }} {{ estudiante.pri_apellido }} {{ estudiante.seg_apellido }}</div>
              </div>
              <div class="kd-info-field">
                <div class="kd-field-label">Documento de identidad</div>
                <div class="kd-field-value">{{ estudiante.num_doc }}</div>
              </div>
              <div class="kd-info-field">
                <div class="kd-field-label">Fecha de elaboración</div>
                <div class="kd-field-value">{{ date }}</div>
              </div>
            </div>

            <!-- SUMMARY CARDS -->
            <div class="kd-summary-section">
              <div class="kd-section-label">Resumen financiero</div>
              <div class="kd-cards-grid">
                <div class="kd-stat-card kd-sc-total">
                  <div class="kd-sc-label">Total del plan</div>
                  <div class="kd-sc-val">Bs {{ fmtNum(total_plan) }}</div>
                  <div class="kd-sc-note">{{ plan_pagos.length }} cuotas</div>
                </div>
                <div class="kd-stat-card kd-sc-paid">
                  <div class="kd-sc-label">Monto pagado</div>
                  <div class="kd-sc-val">Bs {{ fmtNum(ya_pagado) }}</div>
                  <div class="kd-sc-note">{{ cuotas_canceladas }} pagadas</div>
                </div>
                <div class="kd-stat-card kd-sc-pending">
                  <div class="kd-sc-label">Saldo vencido</div>
                  <div class="kd-sc-val">Bs {{ saldo_pendiente }}</div>
                  <div class="kd-sc-note">en mora</div>
                </div>
                <div class="kd-stat-card kd-sc-pct">
                  <div class="kd-sc-label">Avance</div>
                  <div class="kd-sc-val">{{ porcentaje_avance.toFixed(1) }}%</div>
                  <div class="kd-sc-note">del plan cubierto</div>
                </div>
              </div>
            </div>

            <!-- PROGRESS BAR -->
            <div class="kd-progress-section">
              <div class="kd-progress-track">
                <div class="kd-progress-fill" :style="{ width: porcentaje_avance + '%' }"></div>
              </div>
              <div class="kd-progress-meta">
                <strong>Bs {{ fmtNum(ya_pagado) }} pagados</strong>
                <span>Bs {{ fmtNum(total_saldo) }} restantes · total Bs{{ fmtNum(total_plan) }}</span>
              </div>
            </div>

            <!-- TABLE -->
            <div class="kd-table-section">
              <div class="kd-section-label">Detalle de cuotas</div>
              <table class="kd-table">
                <thead>
                  <tr>
                    <th style="width:22%">Concepto</th>
                    <th style="width:5%">N° de cuota</th>
                    <th style="width:13%">Fecha de vencimiento</th>
                    <th style="width:12%">Cuota mensual</th>
                    <th style="width:10%">Saldo pendiente</th>
                    <th style="width:8%">Estado de pago</th>
                    <th style="width:7%">Cuatrimestre</th>
                    <th style="width:13%">Fecha(s) pago</th>
                    <th style="width:10%">Estado de vencimiento</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="row in plan_pagos_con_separadores" :key="row.id"
                      :class="row._sep ? 'kd-q-separator' : getRowClass(row)">
                    <td v-if="row._sep" colspan="9" style="padding: 0;"><div class="kd-q-sep-line"></div></td>
                    <template v-if="!row._sep">
                      <td class="kd-concept-cell">{{ row.concepto_pago }}</td>
                      <td><span class="kd-num-circle">{{ row.nro_cuota }}</span></td>
                      <td class="kd-date-cell">{{ row.fecha_pago }}</td>
                      <td class="kd-amount-cell">Bs {{ row.monto }}</td>
                      <td :class="['kd-amount-cell', getSaldoClass(row)]">Bs {{ row.saldo }}</td>
                      <td class="kd-date-cell" style="font-size:0.8em">{{ row.plazo_pago == 'CANCELADO' ? 'PAGADO' : 'PENDIENTE' }}</td>
                      <td class="kd-date-cell" style="font-size:0.8em">{{ getQuarter(row.fecha_pago) }}</td>
                      <td class="kd-date-cell kd-pagos-fechas">
                        <template v-if="getFechasPago(row.id).length">
                          <div v-for="(f, i) in getFechasPago(row.id)" :key="i">{{ f }}</div>
                        </template>
                        <span v-else style="color:#bbb">—</span>
                      </td>
                      <td><span :class="['kd-badge', getRowStatus(row).badge]">{{ getRowStatus(row).text }}</span></td>
                    </template>
                  </tr>
                </tbody>
              </table>
            </div>

            <!-- PLAN TOTALS -->
            <div class="kd-totals-section">
              <div class="kd-section-label">{{ xplan_programa.nombre }}</div>
              <div class="kd-totals-grid">
                <div class="kd-total-row">
                  <span class="kd-total-label">Valor total</span>
                  <span class="kd-total-val">Bs {{ fmtNum(total_plan) }}</span>
                </div>
                <div class="kd-total-row">
                  <span class="kd-total-label">Cuotas pagadas</span>
                  <span class="kd-total-val kd-tr-green">Bs {{ fmtNum(ya_pagado) }}</span>
                </div>
                <div class="kd-total-row">
                  <span class="kd-total-label">Cuotas vencidas</span>
                  <span class="kd-total-val kd-tr-red">Bs {{ saldo_pendiente }}</span>
                </div>
                <div class="kd-total-row">
                  <span class="kd-total-label">Cuotas pendientes</span>
                  <span class="kd-total-val kd-tr-amber">Bs {{ saldo_futuro }}</span>
                </div>
              </div>
            </div>

            <!-- STATUS CALLOUTS -->
            <div class="kd-status-section">
              <div :class="['kd-callout', tiene_mora ? 'kd-callout-warn' : 'kd-callout-ok']">
                <div class="kd-cl-title">Estado al {{ date }}</div>
                <div class="kd-cl-body" v-if="!tiene_mora">
                  No tiene cuotas vencidas ni pagos en mora. Se encuentra al día con sus obligaciones.
                </div>
                <div class="kd-cl-body" v-else>
                  Tiene cuotas vencidas por un total de <strong>Bs {{ saldo_pendiente }}</strong>.
                </div>
              </div>
              <div class="kd-callout kd-callout-info" v-if="proximo_pago && proximo_pago.length">
                <div class="kd-cl-title">Próximo pago · {{ proximo_pago[0].fecha_pago }} · {{ getQuarter(proximo_pago[0].fecha_pago) }}</div>
                <div class="kd-cl-body">
                  <div v-for="(item, i) in proximo_pago" :key="i">
                    {{ item.concepto_pago }} cuota {{ item.nro_cuota }}: <strong>Bs {{ item.monto }}</strong>
                  </div>
                </div>
              </div>
            </div>

            <!-- FOOTER -->
            <div class="kd-footer">
              <div class="kd-footer-contact">
                <div class="kd-fc-name" v-if="asesor">
                  {{ asesor.sexo === 'M' ? 'Licenciado' : 'Licenciada' }}: {{ asesor.nombres }} {{ asesor.pri_apellido }} {{ asesor.seg_apellido }}
                </div>
                <div class="kd-fc-detail">
                  Departamento Administrativo - Contable · {{ sede.nombre }}<br>
                  <template v-if="sede.telefono1">Cel.: {{ sede.telefono1 }}{{ sede.telefono2 ? ` · ${sede.telefono2}` : '' }}<br></template>
                  <template v-if="sede.direccion">{{ sede.direccion }}<template v-if="sede.ciudad && sede.ciudad.nombre"> · {{ sede.ciudad.nombre }}, Bolivia</template></template>
                </div>
              </div>
              <div class="kd-footer-right">
                <div class="kd-fr-label">Documento generado</div>
                <div class="kd-fr-date">{{ date }}</div>
              </div>
            </div>

          </div>
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn :disabled="$store.state.isonlyread" color="red lighten-2" rounded @click="printRecibo">
            <v-icon class="mr-1">mdi-printer</v-icon> Imprimir o PDF <v-icon class="ml-1">mdi-file-pdf</v-icon>
          </v-btn>
          <v-btn color="blue darken-1" outlined rounded @click="closeDialog">
            Cerrar <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-row>
</template>

<script>
import { Printd } from 'printd';
import moment from 'moment';
import { mapState } from 'vuex';
import xaxios from '@/xaxios';
import gql from 'graphql-tag';
import { concepto_ids_orden } from '@/views/upi/planes/utils';

moment.locale('es');

export default {
  data() {
    return {
      cssText: null,
      firma_path: process.env.VUE_APP_URL_BG_FIRMA_USER,
      api_rest: process.env.VUE_APP_API_REST,
      dialog: false,
      estudiante: null,
      programa: null,
      asesor: null,
      cobros_programa: [],
      plan_pagos: [],
      recibos: [],
      date: null,
      totales: [],
      posgraduante_str: 'ESTUDIANTE',
      xplan_programa: {},
    };
  },
  watch: {
    dialog(val) {
      val || this.closeDialog();
    },
  },
  computed: {
    ...mapState({
      sede: (state) => state.modsede.items.find((t) => t.id == state.CARGO.sede.id),
    }),
    getcobros_programa() {
      return this.cobros_programa.filter((x) => x.monto);
    },
    saldo_pendiente() {
      const hoy = new Date();
      hoy.setHours(0, 0, 0, 0);
      return this.plan_pagos
        .filter((item) => {
          if (!item.fecha_pago) return false;
          return new Date(item.fecha_pago) < hoy;
        })
        .reduce((acc, item) => acc + (Number(item.saldo) || 0), 0)
        .toFixed(2);
    },
    total_plan() {
      return this.plan_pagos.reduce((acc, item) => acc + (Number(item.monto) || 0), 0);
    },
    total_saldo() {
      return this.plan_pagos.reduce((acc, item) => acc + (Number(item.saldo) || 0), 0);
    },
    ya_pagado() {
      return this.total_plan - this.total_saldo;
    },
    cuotas_canceladas() {
      return this.plan_pagos.filter((item) => Number(item.saldo) === 0).length;
    },
    porcentaje_avance() {
      if (!this.total_plan) return 0;
      return Math.min(100, (this.ya_pagado / this.total_plan) * 100);
    },
    tiene_mora() {
      const hoy = new Date();
      hoy.setHours(0, 0, 0, 0);
      return this.plan_pagos.some((item) => {
        if (!item.fecha_pago) return false;
        return new Date(item.fecha_pago) < hoy && Number(item.saldo) > 0;
      });
    },
    proximo_pago() {
      const hoy = new Date();
      hoy.setHours(0, 0, 0, 0);
      const pendientes = [...this.plan_pagos]
        .filter((item) => {
          if (!item.fecha_pago) return false;
          return new Date(item.fecha_pago) >= hoy && Number(item.saldo) > 0;
        })
        .sort((a, b) => new Date(a.fecha_pago) - new Date(b.fecha_pago));
      if (!pendientes.length) return null;
      const nextFecha = pendientes[0].fecha_pago;
      return pendientes.filter((item) => item.fecha_pago === nextFecha);
    },
    plan_pagos_por_fecha() {
      return [...this.plan_pagos].sort((a, b) => {
        const dateDiff = new Date(a.fecha_pago) - new Date(b.fecha_pago);
        if (dateDiff !== 0) return dateDiff;
        const aPagado = Number(a.saldo) === 0 ? 0 : 1;
        const bPagado = Number(b.saldo) === 0 ? 0 : 1;
        return aPagado - bPagado;
      });
    },
    plan_pagos_con_separadores() {
      const result = [];
      this.plan_pagos_por_fecha.forEach((item, i) => {
        if (i > 0 && this.getQuarter(item.fecha_pago) !== this.getQuarter(this.plan_pagos_por_fecha[i - 1].fecha_pago)) {
          result.push({ _sep: true, id: 'sep-' + item.id });
        }
        result.push(item);
      });
      return result;
    },
    saldo_futuro() {
      const hoy = new Date();
      hoy.setHours(0, 0, 0, 0);
      return this.plan_pagos
        .filter((item) => {
          if (!item.fecha_pago) return false;
          return new Date(item.fecha_pago) >= hoy && Number(item.saldo) > 0;
        })
        .reduce((acc, item) => acc + (Number(item.saldo) || 0), 0)
        .toFixed(2);
    },
  },
  methods: {
    showThisView(estudiante, plan_programa, plan_pagos, programa, idinscripcion) {
      this.xplan_programa = plan_programa;
      if (!plan_programa.cobros_programa) plan_programa.cobros_programa = [];
      this.programa = programa;
      this.cobros_programa = plan_programa.cobros_programa.map((cobro) => ({ ...cobro, monto: 0 }));
      this.getkardex(idinscripcion);
      this.getRecibos(idinscripcion);
      this.getSede();
      const vue = this;
      this.dialog = true;
      this.date = moment().format('DD MMMM [del] YYYY');
      this.estudiante = estudiante;
      plan_pagos.forEach((x) => {
        const conceptoPagoId = x.concepto_pago_id || (x.concepto_pago && x.concepto_pago.id);
        const monto = Number(x.monto ?? x.total) || 0;
        const concepto = vue.cobros_programa.find((c) => c.concepto_pago.id == conceptoPagoId);
        if (concepto) concepto.monto += monto;
      });
      if (
        this.programa.nombre_compuesto.includes('LICENCIATURA') ||
        this.programa.nombre_compuesto.includes('TÉCNICO')
      ) {
        this.posgraduante_str = 'ESTUDIANTE';
      } else {
        this.posgraduante_str = 'ESTUDIANTE';
      }
    },
    fmtNum(n) {
      const num = Number(n) || 0;
      return num.toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    },
    fixed(m) {
      if (!m) return '';
      return m.toFixed(2);
    },
    isOverdue(item) {
      if (!item.fecha_pago) return false;
      const hoy = new Date();
      hoy.setHours(0, 0, 0, 0);
      return new Date(item.fecha_pago) < hoy;
    },
    getRowClass(item) {
      const saldo = Number(item.saldo) || 0;
      if (saldo === 0) return 'kd-row-paid';
      return this.isOverdue(item) ? 'kd-row-overdue' : 'kd-row-future';
    },
    getSaldoClass(item) {
      const saldo = Number(item.saldo) || 0;
      if (saldo === 0) return 'kd-saldo-ok';
      return this.isOverdue(item) ? 'kd-saldo-venc' : 'kd-saldo-pend';
    },
    getQuarter(fecha) {
      if (!fecha) return '';
      const mes = new Date(fecha).getMonth() + 1;
      if (mes <= 4) return 'Q1';
      if (mes <= 8) return 'Q2';
      return 'Q3';
    },
    isQuarterChange(index) {
      if (index === 0) return false;
      const prev = this.plan_pagos_por_fecha[index - 1];
      const curr = this.plan_pagos_por_fecha[index];
      return this.getQuarter(curr.fecha_pago) !== this.getQuarter(prev.fecha_pago);
    },
    getRowStatus(item) {
      const saldo = Number(item.saldo) || 0;
      if (saldo === 0) return { badge: 'kd-b-ok', text: 'Pagado' };
      if (this.isOverdue(item)) return { badge: 'kd-b-venc', text: 'Vencido' };
      return { badge: 'kd-b-fut', text: 'Pendiente' };
    },
    getRecibos(inscripcion_id) {
      xaxios
        .post(`${this.api_rest}/api/pagos/recibos/buscar/inscripcion`, { inscripcion_id })
        .then(({ data }) => (this.recibos = data ? data : []));
    },
    getFechasPago(cuota_id) {
      return this.recibos
        .filter((r) => r.estado && r.detalle && r.detalle.some((d) => d.cuota_id === cuota_id))
        .map((r) => r.fecha_pago)
        // .filter((v, i, a) => a.indexOf(v) === i);
    },
    getkardex(idinscripcion) {
      const vue = this;
      const url = `${process.env.VUE_APP_API_REST}/api/v1/inscripcion/${idinscripcion}/plan-pago/kardex`;
      xaxios.get(url).then(({ data }) => {
        window.console.log('KARDEX:', data.data);
        const unidad = this.$store.state.CARGO.sede.unidad_negocio;
        if (unidad == 15) {
          const prioridad = new Map(concepto_ids_orden.map((id, index) => [id, index]));
          data.data.sort((a, b) => {
            const prioridadA = prioridad.get(a.concepto_pago_id) ?? Infinity;
            const prioridadB = prioridad.get(b.concepto_pago_id) ?? Infinity;
            if (prioridadA !== prioridadB) return prioridadA - prioridadB;
            return a.nro_cuota - b.nro_cuota;
          });
          this.cobros_programa.sort((a, b) => {
            const prioridadA = prioridad.get(a.concepto_pago.id) ?? Infinity;
            const prioridadB = prioridad.get(b.concepto_pago.id) ?? Infinity;
            return prioridadA - prioridadB;
          });
        }
        vue.plan_pagos = data.data.map((plan) => ({
          ...plan,
          monto: (Number(plan.total) || 0).toFixed(2),
          saldo: (Number(plan.saldo) || 0).toFixed(2),
        }));
      });
    },
    formatDate(date) {
      if (!date) return null;
      const [year, month, day] = date.slice(0, 10).split('-');
      return `${day}/${month}/${year}`;
    },
    printRecibo() {
      const d = new Printd();
      d.print(document.getElementById('html-kardexupi-bol'), [this.cssText]);
    },
    getSede() {
      let id = this.$store.state.CARGO.sede.id;
      const sql = gql`query{getSede(id: ${id}) { id nombre nombre_recibo modelo_recibo direccion telefono1 ${''}}}`;
      this.$apollo.query({ query: sql }).then(({ data }) => {
        this.sede.modelo_recibo = process.env.VUE_APP_URL_BG_RECIBO_SEDE + data.getSede.modelo_recibo;
      });
    },
    closeDialog() {
      this.dialog = false;
      this.$nextTick(() => {
        this.cobros_programa = [];
        this.plan_pagos = [];
        this.recibos = [];
        this.estudiante = null;
        this.programa = null;
        this.date = null;
      });
    },
    getimgkardex(u) {
      if(u && u.id == 301){
        return 'img/bg_kardex_upi.png';
      }

      let unidad = this.$store.state.CARGO.sede.unidad_negocio;
      if (unidad == 1) {
        if (!u) return 'img/bg_kardex.png';
        else if (u.id == 128) return 'img/bg_kardexubj.png';
        else if (u.id == 2) return 'img/bg_kardexuajms.png';
        else return 'img/bg_kardex.png';
      } else if (unidad == 2) {
        if (!u) return 'img/bg_kardex_cca.webp';
        else if (u.id == 128) return 'img/bg_kardexubj_cca.webp';
        else if (u.id == 2) return 'img/bg_kardexuajms_cca.webp';
        else if (u.id == 9) return 'img/bg_kardexxx_cca.webp';
        else return 'img/bg_kardex_cca.webp';
      } else if (unidad == 3) {
        return 'img/bg_kardex_ck.webp';
      } else if (unidad == 10) {
        if (!u) return 'img/bg_kardex_dbs.webp';
        else if (u.id == 2) return 'img/bg_kardex_dbsuajms.webp';
        else if (u.id == 9) return 'img/bg_kardex_dbsxx.webp';
        return 'img/bg_kardex_dbs.webp';
      } else if (unidad == 14) {
        return this.sede.modelo_recibo;
      } else if (unidad == 15) {
        return this.sede.modelo_recibo;
      }
      return 'img/bg_kardex.png';
    },
  },
  mounted() {
    this.asesor = this.$store.state.DATA_USER;
    this.cssText = `
      *, *::before, *::after { box-sizing: border-box; }
      body { font-family: 'Roboto', Arial, sans-serif; font-size: 14px; color: #1a1a18; }

      .kd-topbar {
        background: #ff8a00; color: white; padding: 8px 20px;
        display: flex; justify-content: space-between; align-items: center;
        font-size: 11px; letter-spacing: 0.06em; text-transform: uppercase; font-weight: 500;
      }
      .kd-topbar-title { opacity: 0.85; white-space: nowrap; overflow: hidden; text-overflow: ellipsis; max-width: 75%; }

      .kd-doc-title {
        text-align: center; padding: 10px 20px 6px;
        font-size: 17px; font-weight: 700; letter-spacing: 0.08em; text-transform: uppercase;
        color: #ff8a00; border-bottom: 2px solid #ff8a00;
      }

      .kd-banner-img { display: block; width: 100%; max-height: 180px; object-fit: contain; }

      .kd-student-section {
        padding: 16px 20px; background: #f5f5f5; border-bottom: 1px solid rgba(0,0,0,0.1);
        display: grid; grid-template-columns: repeat(3, 1fr); gap: 16px;
      }
      .kd-field-label { font-size: 10px; text-transform: uppercase; letter-spacing: 0.08em; color: #888; margin-bottom: 3px; font-weight: 500; }
      .kd-field-value { font-size: 13px; font-weight: 500; color: #1a1a18; }

      .kd-section-label { font-size: 10px; text-transform: uppercase; letter-spacing: 0.1em; color: #888; margin-bottom: 12px; font-weight: 500; }

      .kd-summary-section { padding: 16px 20px; border-bottom: 1px solid rgba(0,0,0,0.1); }
      .kd-cards-grid { display: grid; grid-template-columns: repeat(4, 1fr); gap: 10px; }
      .kd-stat-card { border: 1px solid rgba(0,0,0,0.1); border-radius: 4px; padding: 12px 14px; background: white; }
      .kd-sc-label { font-size: 10px; text-transform: uppercase; letter-spacing: 0.07em; color: #888; margin-bottom: 6px; }
      .kd-sc-val { font-size: 18px; font-weight: 600; line-height: 1.2; margin-bottom: 4px; }
      .kd-sc-note { font-size: 11px; color: #888; }
      .kd-sc-total { border-top: 3px solid #1e4d8c; } .kd-sc-total .kd-sc-val { color: #1e4d8c; }
      .kd-sc-paid  { border-top: 3px solid #1a5c3a; } .kd-sc-paid  .kd-sc-val { color: #1a5c3a; }
      .kd-sc-pending { border-top: 3px solid #8c2020; } .kd-sc-pending .kd-sc-val { color: #8c2020; }
      .kd-sc-pct   { border-top: 3px solid #8c6a1e; } .kd-sc-pct   .kd-sc-val { color: #8c6a1e; }

      .kd-progress-section { padding: 0 20px 16px; border-bottom: 1px solid rgba(0,0,0,0.1); }
      .kd-progress-track { height: 8px; background: #e0e0e0; border-radius: 20px; overflow: hidden; margin: 6px 0; }
      .kd-progress-fill { height: 100%; background: #1a5c3a; border-radius: 20px; }
      .kd-progress-meta { display: flex; justify-content: space-between; font-size: 11px; color: #888; }
      .kd-progress-meta strong { color: #1a5c3a; }

      .kd-table-section { padding: 16px 20px; border-bottom: 1px solid rgba(0,0,0,0.1); }
      .kd-table { width: 100%; border-collapse: collapse; font-size: 13px; }
      .kd-table thead tr { background: #f5f5f5; border-bottom: 1px solid rgba(0,0,0,0.1); }
      .kd-table th { padding: 8px 10px; text-align: right; font-size: 10px; font-weight: 500; text-transform: uppercase; letter-spacing: 0.07em; color: #888; }
      .kd-table th:first-child { text-align: left; }
      .kd-table tbody tr { border-bottom: 1px solid rgba(0,0,0,0.06); }
      .kd-table tbody tr:last-child { border-bottom: none; }
      .kd-table td { padding: 10px 10px; text-align: right; color: #1a1a18; vertical-align: middle; }
      .kd-table td:first-child { text-align: left; }
      .kd-row-paid    { background: rgba(26,92,58,0.05); }
      .kd-row-overdue { background: rgba(140,32,32,0.04); }
      .kd-row-future  { background: rgba(255,248,225,0.6); }
      .kd-q-separator td { padding: 0; border: none !important; background: transparent; }
      .kd-q-sep-line { margin: 0 14px; height: 2px; background: #ea840c; border-radius: 1px; }
      .kd-concept-cell { font-weight: 500; }
      .kd-num-circle {
        display: inline-flex; width: 22px; height: 22px; align-items: center; justify-content: center;
        background: #dce8f8; color: #1e4d8c; border-radius: 50%; font-size: 11px; font-weight: 500;
      }
      .kd-badge { display: inline-block; padding: 3px 8px; border-radius: 2px; font-size: 10px; font-weight: 500; letter-spacing: 0.04em; text-transform: uppercase; white-space: nowrap; }
      .kd-b-ok   { background: #d4eddf; color: #1a5c3a; }
      .kd-b-venc { background: #f8dcdc; color: #8c2020; }
      .kd-b-fut  { background: #fff3cd; color: #856404; }
      .kd-date-cell   { color: #555; font-size: 12px; }
      .kd-pagos-fechas { font-size: 9px; line-height: 1.6; }
      .kd-amount-cell { font-variant-numeric: tabular-nums; }
      .kd-saldo-ok   { color: #1a5c3a; }
      .kd-saldo-venc { color: #8c2020; font-weight: 600; }
      .kd-saldo-pend { color: #856404; }

      .kd-totals-section { padding: 16px 20px; border-bottom: 1px solid rgba(0,0,0,0.1); }
      .kd-totals-grid { display: grid; grid-template-columns: 1fr 1fr; gap: 8px; }
      .kd-total-row { display: flex; justify-content: space-between; align-items: center; padding: 10px 14px; border: 1px solid rgba(0,0,0,0.1); border-radius: 4px; background: white; }
      .kd-total-label { font-size: 12px; color: #555; }
      .kd-total-val   { font-size: 16px; font-weight: 600; color: #1e4d8c; }
      .kd-total-highlight { background: #fafafa; }
      .kd-tr-red   { color: #8c2020; }
      .kd-tr-green { color: #1a5c3a; }
      .kd-tr-amber { color: #856404; }

      .kd-status-section { padding: 16px 20px; border-bottom: 1px solid rgba(0,0,0,0.1); display: flex; gap: 10px; }
      .kd-callout { flex: 1; border-radius: 4px; padding: 12px 16px; border: 1px solid; }
      .kd-callout-ok   { background: #d4eddf; border-color: rgba(26,92,58,0.2); }
      .kd-callout-ok   .kd-cl-title { color: #1a5c3a; } .kd-callout-ok   .kd-cl-body { color: #1a5c3a; }
      .kd-callout-warn { background: #f8dcdc; border-color: rgba(140,32,32,0.2); }
      .kd-callout-warn .kd-cl-title { color: #8c2020; } .kd-callout-warn .kd-cl-body { color: #8c2020; }
      .kd-callout-info { background: #fff3cd; border-color: rgba(133,100,4,0.2); }
      .kd-callout-info .kd-cl-title { color: #856404; } .kd-callout-info .kd-cl-body { color: #856404; }
      .kd-cl-title { font-size: 11px; font-weight: 600; text-transform: uppercase; letter-spacing: 0.06em; margin-bottom: 4px; }
      .kd-cl-body  { font-size: 12px; line-height: 1.5; }

      .kd-footer { padding: 16px 20px; display: grid; grid-template-columns: 1fr auto; gap: 20px; align-items: end; background: #f5f5f5; }
      .kd-fc-name   { font-size: 13px; font-weight: 500; color: #1a1a18; margin-bottom: 4px; }
      .kd-fc-detail { font-size: 11px; color: #666; line-height: 1.7; }
      .kd-footer-right { text-align: right; }
      .kd-fr-label { font-size: 10px; color: #888; text-transform: uppercase; letter-spacing: 0.07em; margin-bottom: 4px; }
      .kd-fr-date  { font-size: 13px; font-weight: 500; color: #1a1a18; }

      @media print {
        body { background: white; }
        .kd-progress-fill { -webkit-print-color-adjust: exact; print-color-adjust: exact; }
        .kd-stat-card, .kd-callout, .kd-badge, .kd-num-circle { -webkit-print-color-adjust: exact; print-color-adjust: exact; }
      }
    `;
  },
};
</script>

<style>
.kd-topbar {
  background: #ff8a00;
  color: white;
  padding: 8px 20px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  font-size: 11px;
  letter-spacing: 0.06em;
  text-transform: uppercase;
  font-weight: 500;
}
.kd-topbar-title {
  opacity: 0.85;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  max-width: 75%;
}

.kd-doc-title {
  text-align: center;
  padding: 10px 20px 6px;
  font-size: 17px;
  font-weight: 700;
  letter-spacing: 0.08em;
  text-transform: uppercase;
  color: #ff8a00;
  border-bottom: 2px solid #ff8a00;
}
.kd-banner { border-bottom: 1px solid rgba(0,0,0,0.1); }
.kd-banner-img { display: block; width: 100%; max-height: 180px; object-fit: contain; }
.kd-row-paid    { background: rgba(26,92,58,0.05); }

.kd-student-section {
  padding: 16px 20px;
  background: #f5f5f5;
  border-bottom: 1px solid rgba(0,0,0,0.1);
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 16px;
}
.kd-field-label {
  font-size: 10px;
  text-transform: uppercase;
  letter-spacing: 0.08em;
  color: #888;
  margin-bottom: 3px;
  font-weight: 500;
}
.kd-field-value { font-size: 13px; font-weight: 500; color: #1a1a18; }

.kd-section-label {
  font-size: 10px;
  text-transform: uppercase;
  letter-spacing: 0.1em;
  color: #888;
  margin-bottom: 12px;
  font-weight: 500;
}

.kd-summary-section { padding: 16px 20px; border-bottom: 1px solid rgba(0,0,0,0.1); }
.kd-cards-grid { display: grid; grid-template-columns: repeat(4, 1fr); gap: 10px; }
.kd-stat-card {
  border: 1px solid rgba(0,0,0,0.1);
  border-radius: 4px;
  padding: 12px 14px;
  background: white;
}
.kd-sc-label { font-size: 10px; text-transform: uppercase; letter-spacing: 0.07em; color: #888; margin-bottom: 6px; }
.kd-sc-val   { font-size: 18px; font-weight: 600; line-height: 1.2; margin-bottom: 4px; }
.kd-sc-note  { font-size: 11px; color: #888; }
.kd-sc-total   { border-top: 3px solid #1e4d8c; } .kd-sc-total   .kd-sc-val { color: #1e4d8c; }
.kd-sc-paid    { border-top: 3px solid #1a5c3a; } .kd-sc-paid    .kd-sc-val { color: #1a5c3a; }
.kd-sc-pending { border-top: 3px solid #8c2020; } .kd-sc-pending .kd-sc-val { color: #8c2020; }
.kd-sc-pct     { border-top: 3px solid #8c6a1e; } .kd-sc-pct     .kd-sc-val { color: #8c6a1e; }

.kd-progress-section { padding: 0 20px 16px; border-bottom: 1px solid rgba(0,0,0,0.1); }
.kd-progress-track {
  height: 8px;
  background: #e0e0e0;
  border-radius: 20px;
  overflow: hidden;
  margin: 6px 0;
}
.kd-progress-fill {
  height: 100%;
  background: #1a5c3a;
  border-radius: 20px;
  transition: width 0.5s ease;
}
.kd-progress-meta { display: flex; justify-content: space-between; font-size: 11px; color: #888; }
.kd-progress-meta strong { color: #1a5c3a; }

.kd-table-section { padding: 16px 20px; border-bottom: 1px solid rgba(0,0,0,0.1); }
.kd-table { width: 100%; border-collapse: collapse; font-size: 13px; }
.kd-table thead tr { background: #f5f5f5; border-bottom: 1px solid rgba(0,0,0,0.1); }
.kd-table th {
  padding: 8px 10px;
  text-align: right;
  font-size: 10px;
  font-weight: 500;
  text-transform: uppercase;
  letter-spacing: 0.07em;
  color: #888;
}
.kd-table th:first-child { text-align: left; }
.kd-table tbody tr { border-bottom: 1px solid rgba(0,0,0,0.06); }
.kd-table tbody tr:last-child { border-bottom: none; }
.kd-table td { padding: 10px 10px; text-align: right; color: #1a1a18; vertical-align: middle; }
.kd-table td:first-child { text-align: left; }
.kd-row-overdue { background: rgba(140,32,32,0.04); }
.kd-row-future  { background: rgba(255,248,225,0.5); }
.kd-row-q-break td { border-top: 2px solid #1e4d8c !important; }
.kd-concept-cell { font-weight: 500; }
.kd-num-circle {
  display: inline-flex;
  width: 22px; height: 22px;
  align-items: center; justify-content: center;
  background: #dce8f8;
  color: #1e4d8c;
  border-radius: 50%;
  font-size: 11px;
  font-weight: 500;
}
.kd-badge {
  display: inline-block;
  padding: 3px 8px;
  border-radius: 2px;
  font-size: 10px;
  font-weight: 500;
  letter-spacing: 0.04em;
  text-transform: uppercase;
  white-space: nowrap;
}
.kd-b-ok   { background: #d4eddf; color: #1a5c3a; }
.kd-b-venc { background: #f8dcdc; color: #8c2020; }
.kd-b-fut  { background: #fff3cd; color: #856404; }
.kd-date-cell   { color: #555; font-size: 12px; }
.kd-amount-cell { font-variant-numeric: tabular-nums; }
.kd-saldo-ok   { color: #1a5c3a; }
.kd-saldo-venc { color: #8c2020; font-weight: 600; }
.kd-saldo-pend { color: #856404; }

.kd-totals-section { padding: 16px 20px; border-bottom: 1px solid rgba(0,0,0,0.1); }
.kd-totals-grid { display: grid; grid-template-columns: 1fr 1fr; gap: 8px; }
.kd-total-row {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 10px 14px;
  border: 1px solid rgba(0,0,0,0.1);
  border-radius: 4px;
  background: white;
}
.kd-total-label { font-size: 12px; color: #555; }
.kd-total-val   { font-size: 16px; font-weight: 600; color: #1e4d8c; }
.kd-total-highlight { background: #fafafa; }
.kd-tr-red   { color: #8c2020; }
.kd-tr-green { color: #1a5c3a; }
.kd-tr-amber { color: #856404; }
.kd-q-sep-line { margin: 0 14px; height: 2px; background: #ea840c; border-radius: 1px; }

.kd-status-section {
  padding: 16px 20px;
  border-bottom: 1px solid rgba(0,0,0,0.1);
  display: flex;
  gap: 10px;
}
.kd-callout { flex: 1; border-radius: 4px; padding: 12px 16px; border: 1px solid; }
.kd-callout-ok   { background: #d4eddf; border-color: rgba(26,92,58,0.2); }
.kd-callout-ok   .kd-cl-title { color: #1a5c3a; }
.kd-callout-ok   .kd-cl-body  { color: #1a5c3a; }
.kd-callout-warn { background: #f8dcdc; border-color: rgba(140,32,32,0.2); }
.kd-callout-warn .kd-cl-title { color: #8c2020; }
.kd-callout-warn .kd-cl-body  { color: #8c2020; }
.kd-callout-info { background: #fff3cd; border-color: rgba(133,100,4,0.2); }
.kd-callout-info .kd-cl-title { color: #856404; }
.kd-callout-info .kd-cl-body  { color: #856404; }
.kd-cl-title {
  font-size: 11px;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.06em;
  margin-bottom: 4px;
}
.kd-cl-body { font-size: 12px; line-height: 1.5; }

.kd-footer {
  padding: 16px 20px;
  display: grid;
  grid-template-columns: 1fr auto;
  gap: 20px;
  align-items: end;
  background: #f5f5f5;
}
.kd-fc-name   { font-size: 13px; font-weight: 500; color: #1a1a18; margin-bottom: 4px; }
.kd-fc-detail { font-size: 11px; color: #666; line-height: 1.7; }
.kd-footer-right { text-align: right; }
.kd-fr-label { font-size: 10px; color: #888; text-transform: uppercase; letter-spacing: 0.07em; margin-bottom: 4px; }
.kd-fr-date  { font-size: 13px; font-weight: 500; color: #1a1a18; }
</style>
